var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bb-doc-location",class:{'bb-doc-location_office': _vm.locationOffice}},[(_vm.locationOffice)?_c('i',{staticClass:"bb-doc-location__icon icon-toggle-office"}):_c('i',{staticClass:"bb-doc-location__icon bb-doc-location__icon_client icon-toggle-client"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-725cb16b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dissemination/Sales/CRM/ContactCard/ContactDocuments/DocumentLocation/DocumentLocation.vue
// module id = null
// module chunks = 